import {useState} from "react";
import {BuyerSelectWidget} from "./BuyerSelectWidget";
import {Button, Card, Collapse, DatePicker, Row, Col, Input, InputNumber, message} from 'antd';
import {SavePurchaseOrderWidget} from "./SavePurchaseOrderWIdget";
import {createPurchaseOrder, insertPurchaseOrderTask} from "../../api/Api";
import {ProductDisplayWidget} from "../fulfillment/ProductDisplayWidget";
import {PurchaseOrderLineItemTable} from "./PurchaseOrderLineItemTable";
import {NewTask} from "../tasks/NewTask";
import {SimpleTaskTable} from "./SimpleTaskTable";

const {TextArea} = Input;


export const NewPurchaseOrder = ({refresh, onRefresh, onApiFail, props}) => {
    const [selectedBuyer, setSelectedBuyer] = useState(undefined);
    const [buyerValue, setBuyerValue] = useState(undefined);
    const [dueDate, setDueDate] = useState(undefined);
    const [product, setProduct] = useState(undefined);
    const [quantity, setQuantity] = useState(undefined);
    const [productList, setProductList] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    const onBuyerSelect = (val) => {
        setSelectedBuyer(val);
    }

    const onDateChange = (date, dateString) => {
        setDueDate(dateString);
    }

    const [spin, setSpin] = useState(false)
    const [notes, setNotes] = useState("");

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onSave = () => {
        console.log('save')
        setSpin(true);
        createPurchaseOrder(selectedBuyer.id, dueDate, notes, productList).then(r => {
            setSpin(false);
            if (tasks.length > 0) {
                return insertPurchaseOrderTask(r.id, tasks);
            } else {
                return Promise.resolve({});
            }
        }).then(r => {
            if (onRefresh) onRefresh();
            clearForm();
        }).catch (e => {
            console.log(`save po failed ${JSON.stringify(e)}`)
            setSpin(false);
        })
    }

    const clearForm = () => {
        setSelectedBuyer(undefined);
        setBuyerValue(undefined);
        setDueDate(undefined);
        setNotes("");
        setQuantity(undefined);
        setProduct(undefined);
        setProductList([]);
        setTasks([]);
    }

    const onQuantityChange = (val) => {
        setQuantity(val);
    }

    const onTableQuantityChange = (record, quantity) => {
        const nextList = [...productList];
        for (let i=0; i<nextList.length; i++) {
            if (record.id === nextList[i].id) {
                nextList[i].quantity = quantity;
                break;
            }
        }
        setProductList(nextList);
    }

    const onProductSelect = (item) => {
        setProduct(item);
    }

    const onSaveProduct = () => {
        const nextList = [...productList];
        for (let i=0; i<productList.length; i++) {
            // don't allow duplicate items
            if (productList[i].id === product.id) {
                messageApi.open({
                    type: 'error',
                    content: 'Item already exists on purchase order'
                })
                setProduct(undefined);
                setQuantity(undefined);
                return;
            }
        }
        nextList.push({
            ...product,
            quantity
        });
        setProduct(undefined);
        setQuantity(undefined);
        setProductList(nextList);
    }

    const onDeleteLineItem = (index) => {
        const nextList = [];
        for (let i=0; i<productList.length; i++) {
            if (i !== index) {
                nextList.push(productList[i]);
            }
        }
        setProductList(nextList);
    }

    const onNewTask = (task) => {
        const nextTasks = [...tasks];
        nextTasks.push({
            ...task,
            id: task.id
        });
        setTasks(nextTasks);
    }

    const rowStyle = {paddingTop: '5px', paddingBottom: '5px'}
    const saveDisabled = (product === null) || (product === undefined) || (quantity === null) || (quantity === undefined);

    const itemWidget = <div>
        <Row style={rowStyle}>
            <ProductDisplayWidget productId={product ? product.id : null} onSelect={onProductSelect} refresh={refresh} onApiFail={onApiFail} />
        </Row>
        <Row style={rowStyle}><InputNumber style={{width:150}} placeholder={'Quantity'} value={quantity} onChange={onQuantityChange}/></Row>
        <Row style={rowStyle}><Button disabled={saveDisabled} onClick={onSaveProduct}>Save Product</Button></Row>
    </div>

    return <div style={{textAlign: 'left'}}>
        {contextHolder}
        <Row  style={{paddingTop: '5px', paddingBottom: '5px'}}>
        </Row>
        <Row  style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <BuyerSelectWidget selectedBuyer={selectedBuyer} onSelect={onBuyerSelect} value={buyerValue} setValue={setBuyerValue} onApiFail={onApiFail} />
        </Row><p/>
        <Card title={'Due Date'}><Row><DatePicker onChange={onDateChange} /></Row></Card><p/>
        <Card title={'Notes'}>
            <Row style={{paddingTop: '5px', paddingBottom: '5px'}}><Col span={18}><TextArea value={notes} onChange={onNotesChange} placeholder={'Notes'} maxLength={10240} rows={12} showCount /></Col></Row>
        </Card>
        <Card title={'P.O. Items'}>
            {(productList.length > 0) &&
                <PurchaseOrderLineItemTable products={productList} onDelete={onDeleteLineItem} onQuantityChange={onTableQuantityChange} />
            }
            {itemWidget}
        </Card>
        <Card title={'Tasks'}>
            {(tasks.length > 0) &&
                <SimpleTaskTable tasks={tasks} />
            }
            <Collapse ghost bordered={false} items={[
                {
                    key: 1,
                    label: <b>Add Tasks</b>,
                    children: <NewTask onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh} onNewTask={onNewTask} />
                }
            ]}/>
        </Card>
        <SavePurchaseOrderWidget spin={spin} dueDate={dueDate} buyer={selectedBuyer} products={productList} onSave={onSave}/>
        <Row  style={{paddingTop: '5px', paddingBottom: '5px'}}>
        </Row>
    </div>
}